import { createRoot } from "react-dom/client";

import { MainRoot } from "@/mainRoot";

const root = document.querySelector("#root")!;

const createdRoot = createRoot(root);

createdRoot.render(<MainRoot />);
